import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { scheduledMessagesApi } from '@/lib/api/scheduled-messages.api';

import type { ScheduledMessageQuery } from '@repo/shared-types';

const QUERY_KEY = ['scheduled-messages'];

export const useScheduledMessages = (query: Partial<ScheduledMessageQuery> = {}) =>
  useQuery({
    queryKey: [...QUERY_KEY, query],
    queryFn: () => scheduledMessagesApi.getAll(query),
    // Pending rows go out on their own; a slow refresh keeps the list honest
    // without the operator having to reload to see something disappear.
    refetchInterval: 30_000,
  });

export const useCancelScheduledMessage = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => scheduledMessagesApi.cancel(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
